import { render } from "./TheC01ItemThumbnailsSp.vue?vue&type=template&id=4ba9c3a4&scoped=true&ts=true"
import script from "./TheC01ItemThumbnailsSp.vue?vue&type=script&lang=ts"
export * from "./TheC01ItemThumbnailsSp.vue?vue&type=script&lang=ts"

import "./TheC01ItemThumbnailsSp.vue?vue&type=style&index=0&id=4ba9c3a4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba9c3a4"]])

export default __exports__